import React from 'react';
import {PropTypes} from 'prop-types';
const ValueContainer = React.forwardRef(function ValueContainer(props, ref) {
   return (
      <div ref={ref} className={props.selectProps.classes.valueContainer}>
         {props.children}
      </div>
   );
});

ValueContainer.propTypes = {
   /**
    * The children to be rendered.
    */

   children: PropTypes.node,
   selectProps: PropTypes.object.isRequired
};
export default ValueContainer;
